export default "__VITE_ASSET__BHWJS7W2__"